import React from 'react';
import { TimePicker } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const { RangePicker } = TimePicker;

export const TimeRangePicker = ({
  label,
  error,
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  startTime,
  endTime,
  onChange,
  format = 'HH:mm',
  ...props
}) => {
  const handleChange = (times) => {
    onChange?.(times);
  };

  const value = startTime && endTime ? [dayjs(startTime), dayjs(endTime)] : null;

  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <RangePicker
        value={value}
        onChange={handleChange}
        format={format}
        status={error ? 'error' : ''}
        style={{ width: '100%' }}
        {...props}
      />
    </InputWrapper>
  );
};

TimeRangePicker.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
  startTime: PropTypes.object,
  endTime: PropTypes.object,
  onChange: PropTypes.func,
  format: PropTypes.string,
};

export default TimeRangePicker; 